import { useCallback } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { CONFIG } from 'config/environment_variables';
import { LIBRARIES } from 'constant/map';
import {
  IGeocodeResult,
  useGooglePlaces,
} from 'hooks/common/GoogleMap/useGooglePlaces';
import { Logger } from 'utils/logger';

// Use this hook to ensure Google Maps is loaded before using the Google Maps API
export const useGooglePlacesWithLoader = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: CONFIG.MAP_API,
    libraries: LIBRARIES,
  });

  const { getGeocodeByLatLng, getAddressObject } = useGooglePlaces();

  const getGeocodeByLatLngSafe = useCallback(
    async (lat: number, lng: number): Promise<IGeocodeResult[] | null> => {
      if (!isLoaded) {
        Logger.warn({
          message: 'Google Maps API is still loading',
          data: { loadError },
        });
        return null;
      }
      return getGeocodeByLatLng(lat, lng);
    },
    [isLoaded, loadError, getGeocodeByLatLng],
  );

  return {
    getGeocodeByLatLng: getGeocodeByLatLngSafe,
    getAddressObject,
    isLoaded,
    loadError,
  };
};
